export default __webpack_public_path__ + "static/media/Completed.ad68c46e.png";